export class DoctorFeeModel
{
doccode = '' ;
patientfee = 0 ;
supervisionperc = 0 ;
chemoperc = 0 ;
radioperc = 0 ;
otherperc = 0 ;
notes = '' ;
compcode = '' ;
userid = '' ;
modifieddate = '2024-01-01' ;

}